import React from "react";
import styled from "styled-components";
import {
  calculateCapacity,
  Cost,
  displayCost,
  getVenuePrimaryPhotoUrl,
  getVenueStartingCost,
  Venue
} from "sweet-global";
import GuestsIcon from "sweet-web/components/icons/GuestsIcon";
import { fadeIn } from "sweet-web/lib/animations";
import { colors } from "sweet-web/lib/styles";

const VenueWrapper = styled.a`
  margin: 10px;
  min-width: 200px;
  /* max-width: 400px; */
  flex: 1;
  flex-basis: 21%;
  background-color: ${colors.white};

  transition: all 150ms cubic-bezier(0.21, 0.94, 0.64, 0.99);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow: hidden;
  ${fadeIn}
  &:hover {
    cursor: default;
    img {
      transform: scale(1.05);
    }
  }
  @media screen and (max-width: 1000px) {
    min-width: 300px;
  }
  @media screen and (max-width: 600px) {
    width: 100%;
  }
`;

const VenueImageWrapper = styled.div`
  width: 100%;
  height: 200px;
  overflow: hidden;
  border-radius: 10px;
  background-color: ${colors.lightGray};
`;

const VenueImage = styled.img`
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 5px;
  transition: all 150ms linear;
`;

const VenueRow = styled.div`
  margin: 10px 0 0px 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
`;

const VenueRowLeft = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`;

const VenueName = styled.h3`
  color: ${colors.nearBlack};
  font-size: 14px;
  font-weight: 700;
  text-align: left;
  width: 100%;
`;

const VenueLabel = styled.p`
  color: ${colors.gray};
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  display: flex;
  flex-direction: row;
`;

const VenuePrice = styled.p`
  color: ${colors.primary};
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
`;

const VenueActive = styled.p<{ active: boolean }>`
  color: ${props => (props.active ? colors.primary : colors.gray)};
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
`;

type Props = {
  venue: Venue;
  onClick: () => void;
  style?: object;
  admin?: boolean;
};
const VenuePreview: React.FC<Props> = props => {
  const { venue, onClick, admin } = props;
  const capacity = calculateCapacity(venue);

  const primaryPhoto = getVenuePrimaryPhotoUrl(venue);

  const costPreview = displayCost(getVenueStartingCost(venue));

  return (
    <VenueWrapper onClick={onClick} style={props.style}>
      <VenueImageWrapper>
        {primaryPhoto && <VenueImage src={primaryPhoto} />}
      </VenueImageWrapper>
      {!admin && (
        <VenueRow>
          <VenueRowLeft>
            <VenueName>{venue.name}</VenueName>
            <VenueLabel>
              <GuestsIcon
                size={14}
                color={colors.gray}
                style={{ marginRight: 8, marginTop: 2 }}
              />
              {capacity.max}
            </VenueLabel>
          </VenueRowLeft>
          {costPreview && <VenuePrice>From {costPreview}</VenuePrice>}
        </VenueRow>
      )}
      {admin && (
        <VenueRow>
          <VenueRowLeft>
            <VenueName>{venue.name}</VenueName>
            <VenueLabel>{`${venue.location.city}`}</VenueLabel>
          </VenueRowLeft>
          <VenueActive active={venue.active}>
            {venue.active === true ? "Active" : "Inactive"}
          </VenueActive>
        </VenueRow>
      )}
    </VenueWrapper>
  );
};
VenuePreview.defaultProps = {
  style: {}
};

export default VenuePreview;
